export const environment = {
  production: true,
  apiUrl: 'https://vinning-containerservice-api-prod.azurewebsites.net/',
  apiToken:'YWE4NDYtYjUzNy01OHZ2LWdkNXAtNWY5NWd2MmQyY2t2OkZCNThRfjJGQ0g2VkJUNlZWTi04aEM1TkRjWkx2cGhEWkdIRVR1ZGhN'
};
